<div class="divider-wrapper">
  <div class="divider"></div>
  <span [class]="'text ' + textClass">{{ text }}</span>
</div>
